import SectionNavi from './sectionnavi';

export default (di) => {
	di
		.setType({type: SectionNavi, name: 'SectionNavi', parent: 'PageComponent'})
	;
};
